<template>

    <VcitaAutoComplete
      class="services-picker"
      :class="{'has-value': !!value, mobile: !$vuetify.breakpoint.mdAndUp}"
      :menu-props="{
        contentClass: `services-picker-menu-content ${!$vuetify.breakpoint.mdAndUp ? 'mobile-menu' : ''}`
      }"
      :value="computedValue"
      :items="listItems"
      hide-details="'auto'"
      :hide-no-data="true"
      :filter="filterItems"
      item-text="name"
      v-bind="{...$props, ...$attrs}"
      item-value="selectId"
      v-on="{...$listeners, input: handleInput}"
      @menu-toggled="handleMenuToggle"
      return-object
      ref="servicesAutocorrect"
      :placeholder="$t(placeholder)"
      :append-icon="getAppendIcon"
      :prepend-inner-icon="getPrependIcon"
    >
      <template v-slot:prepend-item v-if="!$vuetify.breakpoint.mdAndUp">
        <v-layout column>
          <v-layout class="mobile-header py-4 px-5">
            <v-btn
              class="close-button"
              @click="closeClicked"
              icon
            >
              <v-icon size="20">icon-back-16 {{$vuetify.rtl ? 'fa-rotate-180' : ''}}</v-icon>
            </v-btn>
            <v-layout class="mobile-header-text" align-center>
              {{$t(placeholder)}}
            </v-layout>
          </v-layout>
          <v-layout class="px-5 py-5" column>
            <VcitaTextField
              autofocus
              ref="mobileTextInput"
              v-model="mobileFilterText"
              class="mobile-search-input"
              prepend-inner-icon="icon-search"
              :label="$t(placeholder)"
            />
          </v-layout>
        </v-layout>
      </template>
      <template v-slot:selection="selectionItem">
        <ServiceListItem
          :isSelectionItem="true"
          :data="selectionItem"/>
      </template>

      <template v-slot:item="serviceData">
        <ServiceListItem :data="serviceData"/>
      </template>

    </VcitaAutoComplete>

</template>

<script>
  import ServiceListItem from "@/modules/bookings/components/common/ServicesListSelect/ServiceListItem.vue"
  import VcitaAutoComplete from "@/modules/common/components/VcitaAutoComplete/VcitaAutoComplete.vue"
  import {VcitaTextField} from "@/modules/common/components"
export default {
  components: {
    ServiceListItem,
    VcitaAutoComplete,
    VcitaTextField,
  },
  props: {
    categoriesData: {
      type: Array,
      required: true,
    },
    value: {
      type: [Object, String],
      required: false,
    },
    customKey: {
      type: String,
      required: false,
      default: 'common.words.custom'
    },
    placeholder: {
      type: String,
      required: false,
      default: 'appointment.info.short_instructions'
    }
  },
  data() {
    return {
      mobileFilterText: '',
    }
  },
  methods: {
    async handleMenuToggle(val) {
      if(val && !this.$vuetify.breakpoint.mdAndUp) {
        await this.$nextTick()
        const inputElement = this.$refs.mobileTextInput
        inputElement.$el.scrollIntoView()
      }
    },
    async handleInput(val) {
      this.mobileFilterText = ''
      if(typeof val === 'string') {
        this.$emit('input', 'custom');
        return
      }
      let currVal = this.value
      if(val) {
        this.$emit('input', val);
      } else {
        await this.$nextTick()
        this.$emit('input', currVal);
      }
    },
    filterItems(item, queryText, itemText) {
      if(item.header || typeof item === 'string') {
        return true
      }
      return item.name.toLowerCase().indexOf(queryText.toLowerCase()) !== -1
    },
    closeClicked() {
      this.mobileFilterText = ''
      this.$refs.servicesAutocorrect.$children[0].isMenuActive = false
      this.$refs.servicesAutocorrect.openMenu = false
    }
  },
  computed: {
    listItems() {
      let currId = 1;
      const res = this.categoriesData.reduce((acc, item) => {
        let servicesToCopy = item.services
        if(this.mobileFilterText) {
          servicesToCopy = item.services.filter((service) => {
            return this.filterItems(service, this.mobileFilterText)
          })
        }
        if(servicesToCopy.length === 0) {
          return acc
        }
        let newServices = JSON.parse(JSON.stringify(servicesToCopy))
        newServices.forEach(service => {
          if (service) {
            service.selectId = service.id + currId
            currId++
          }
        })
        return acc.concat([
        {header: item.name},
        ...newServices,
      ])}, []);
      if(this.customKey) {
        res.unshift(this.$t(this.customKey));
      }
      return res
    },
    servicesMap() {
      return this.listItems.reduce((acc, service) => {
        acc[service.id] = service
        return acc
      }, {})
    },
    computedValue() {
      if(typeof this.value === 'string') {
        return this.$t(this.customKey)
      }
      if (!this.value) {
        return
      }
      return this.value.id ? this.servicesMap[this.value.id] : this.value
    },
    brandBgColor() {
      return this.$store && this.$store.getters['brandModule/secondaryColor'];
    },
    getAppendIcon() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return 'arrow_drop_down';
      } else if (this.$vuetify.rtl) {
        return 'icon-back-16';
      } else {
        return 'icon-back-16 fa-rotate-180';
      }
    },
    getPrependIcon() {
      return !this.value ? 'icon-Services' : ''
    }
  },
}

</script>

<style lang="scss" scoped>
  @import '@/assets/scss/abstract/_i18n-mixins';
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";
  .mobile-header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }
  .mobile-header-text {
    font-size: 17px;
    font-weight: 600;
  }
  .close-button {
    color: rgba(0, 0, 0, 0.4);
  }
  .search-title {
    font-size: 13px;
    font-weight: 500;
    letter-spacing: -0.20000000298023224px;
  }
  .mobile-search-input {
    ::v-deep {
      .v-input__prepend-inner {
        i {
          color: rgba(0, 0, 0, 0.4) !important;
        }
      }
    }
  }
  .services-picker {
    font-family: var(--primary-font-family);
    margin: 4px;
    border-radius: 6px;
    &.error--text {
      ::v-deep .v-input__control {
        .v-input__slot {
          border: 1px solid #F2514A;
        }
      }
    }
    ::v-deep {
      .v-input__control {
        .v-input__slot {
          max-height: 52px;
          min-height: 52px;
          @include md-and-down {
            border: none;
            padding: 0 !important;
          }
        }
      }
      &:not(.has-value) {
        .v-label {
          height: unset;
          width: 100%;
          position: static !important;

          &.v-label--active {
            transform: none;
          }
        }
      }

      .v-input__prepend-inner {

        min-height: 48px;
        min-width: 48px;
        margin-top: auto;
        margin-bottom: auto;
        @include i-margin-mirror(0, 15px);
        padding: 0;
        background-color: rgba(0, 0, 0, 0.07);
        border-radius: 4px;
        @include md-and-up {
          min-height: 32px;
          min-width: 32px;
          @include i-margin-mirror(0, 12px);
          i {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.54) !important;
          }
        }

        .v-input__icon {
          margin-top: auto;
          margin-bottom: auto;
        }
      }
    }
  }

</style>

<style lang="scss">
  @import '@/assets/scss/abstract/_i18n-mixins';
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";
  .services-picker-menu-content {
    font-family: var(--primary-font-family);
    @include md-and-up {
      max-width: 444px;
    }
    .v-select-list{
      padding-top: 0;
    }
    .v-list-item__content {
      padding: 7px 0;
    }
    .v-list-item:first-child {
      min-height: 40px;
    }
    .v-subheader {
      border-top: 1px solid rgba(0, 0, 0, 0.12);
      padding: 12px 16px 8px;
      box-sizing: content-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 16px;
      font-weight: 600;
      font-size: 11px;
      line-height: 16px;
      text-transform: uppercase;
      color: rgba(0, 0, 0, 0.54)
    }
    &.mobile-menu {
      min-width: 100vw !important;
      max-height: 100vh !important;
      top: 0 !important;
      position: fixed !important;
      left: 0px !important;
      z-index: 100 !important;
      & > .v-select-list {
        min-height: 100vh;
      }
    }
  }
</style>
